export default __webpack_public_path__ + "static/05.01-2e753d350f096b7893bee1b0abc7dd1e.png";